<button [type]="type" [disabled]="disabled" (click)="handleClickEvent($event)" [ngClass]="customClass"
  [attr.aria-label]="ariaLabel">
  <ng-container *ngIf="icon && iconPosition === 'left'">
    <i [class]="icon"></i>
  </ng-container>
    @if(!hideLabel) {
      {{ label }}
    }
  <ng-container *ngIf="icon && iconPosition === 'right'">
    <i [class]="icon"></i>
  </ng-container>
</button>